import React, {Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FormGroup from "@mui/material/FormGroup";
import SvgIcon from "@mui/material/SvgIcon";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import HelpIcon from '@mui/icons-material/Help';

import LookUserInput from "../../user/lookUserInput";
import LookUserPhoneInput from "../../user/lookUserPhoneInput";
import {UserPopupContent} from "../../../visComponents/constants";
import {setUserPopupContent} from "../../../../actions/userFunctions";


const LeadCapturePopupContentInputs = (props) => {

  const {userPopupContent, inputsValidated, setUserPopupContent} = props;

  const forgotPasswordLinkClick = () => {
    setUserPopupContent(userPopupContent === UserPopupContent.forgot ? UserPopupContent.login : UserPopupContent.forgot);
  }

  return (
    <FormGroup className="grohe-lead__form">
      {userPopupContent === UserPopupContent.register ? (
        <Fragment>
          <LookUserInput property={"firstName"} inputsValidated={inputsValidated} shrink={true} />
          <LookUserPhoneInput property={"phoneNumber"} inputsValidated={inputsValidated} shrink={true} />
        </Fragment>
      ) : null}
      <LookUserInput property="email" inputsValidated={inputsValidated} shrink={true} />
      {userPopupContent === UserPopupContent.register
        ? <LookUserInput property="postal" inputsValidated={inputsValidated} shrink={true} />
        : null}
      {userPopupContent === UserPopupContent.login
        ? <LookUserInput property="password" inputsValidated={inputsValidated} shrink={true} />
        : null}
      {userPopupContent === UserPopupContent.login || userPopupContent === UserPopupContent.forgot ? (
        <div>
          {userPopupContent === UserPopupContent.forgot ? (
            <div className="grohe-lead__link"  onClick={forgotPasswordLinkClick}>
              <SvgIcon className="grohe-lead__link-icon">
                <ChevronLeftIcon/>
              </SvgIcon>
              <FormattedMessage id="buttons.back"/>
            </div>
          ) : null}
          {userPopupContent === UserPopupContent.login ? (
            <div className="grohe-lead__link"  onClick={forgotPasswordLinkClick}>
              <SvgIcon className="grohe-lead__link-icon">
                <HelpIcon/>
              </SvgIcon>
              <FormattedMessage id="leadCapturePopup.forgotLink"/>
            </div>
          ) : null}
        </div>
      ) : null}
    </FormGroup>
  )
};

LeadCapturePopupContentInputs.propTypes = {
  inputsValidated: PropTypes.bool.isRequired
}

const mapStateToProps = (store) => {
  const {userPopupContent} = store.userState;

  return {
    userPopupContent,
  };
};

const mapDispatchToProps = {
  setUserPopupContent
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupContentInputs)
